import { style } from '@vanilla-extract/css';

export const recommendationContainer = style({
  width: '100%',
  height: 'auto',
  borderCollapse: 'collapse',
  paddingLeft: 'var(--wt-padding)',
  paddingRight: 'var(--wt-padding)',
  paddingTop: '16px',
  paddingBottom: '16px',
});

export const recommendationInnerContainer = style({
  padding: '16px',
  background: '#f9fafb',
  borderRadius: '5px',
  border: '1px solid #d1d5db',
});

export const imageContainer = style({
  marginBottom: '16px',
  marginRight: '16px',
  verticalAlign: 'top',
  width: '50px',
});

export const contentContainer = style({
  color: '#282828',
  fontSize: '18px',
  fontWeight: '700',
  lineHeight: '24px',
  marginBottom: '16px',
});

export const button = style({
  filter: 'drop-shadow(0 1px 1px rgb(0 0 0 / 0.05))',
  cursor: 'pointer',
  background: '#FFFFFF',
  border: '1px solid #d1d5db',
  borderRadius: '4px',
  color: '#282828',
  fontSize: '14px',
  fontWeight: '600',
  height: '40px',
  lineHeight: '21px',
  width: '100%',
});

export const subtitle = style({
  padding: '0',
  color: '#767676',
  fontSize: '14px',
  fontWeight: '400',
  display: 'block',
});
